import { createInsightsMiddleware } from "instantsearch.js/es/middlewares";
import { useEffect } from "react";
import { useInstantSearch } from "react-instantsearch";
import insightsClient from "search-insights";
import { type InsightsSearchClickEvent } from "search-insights/dist/click";
import { type InsightsSearchConversionEvent } from "search-insights/dist/conversion";

type ClickOrConversionEvent = InsightsSearchClickEvent | InsightsSearchConversionEvent;

export function AlgoliaInsightsMiddleware() {
  const { addMiddlewares } = useInstantSearch();

  const userId = typeof window !== "undefined" && window?.intercomSettings?.user_id;

  useEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient,
      onEvent(event, client) {
        const { insightsMethod, payload, eventType } = event;

        if (insightsMethod && client && (eventType === "click" || eventType === "conversion")) {
          client(insightsMethod, payload as ClickOrConversionEvent);
        }
      },
    });

    // Default user token is just 'anonymous' for now, could be e.g. a Google Analytics token
    insightsClient("setUserToken", "anonymous");

    // If there is a logged-in app user, set that as the authenticated user token
    // Both the userToken and authenticatedUserToken are sent to Aloglia
    // https://www.algolia.com/doc/guides/sending-events/concepts/usertoken/#authenticated-user-token
    if (userId) {
      insightsClient("setAuthenticatedUserToken", String(userId));
    }

    return addMiddlewares(middleware);
  }, [addMiddlewares, userId]);

  return null;
}
